export default {
  mounted () {
    document.addEventListener('visibilitychange', this.handleMarqueeVisibility)
    this.startMarqueePolling()
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.handleMarqueeVisibility)
    this.stopMarqueePolling()
  },
  methods: {
    handleMarqueeVisibility () {
      if (document.hidden) {
        this.stopMarqueePolling()
        return
      }

      // Refresh once when returning, then resume exactly one timer.
      this.fetchMarquees()
      this.startMarqueePolling()
    },
    startMarqueePolling () {
      this.stopMarqueePolling()
      if (document.hidden) return

      this.marqueePollTimer = window.setInterval(() => {
        if (!document.hidden) this.fetchMarquees()
      }, this.marqueePollIntervalMs)
    },
    stopMarqueePolling () {
      if (!this.marqueePollTimer) return
      window.clearInterval(this.marqueePollTimer)
      this.marqueePollTimer = null
    }
  }
}
